import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "app-tabs" }
const _hoisted_2 = ["onClick"]

import { TabId } from '@/core/common';

interface AppTabsProps {
	tabs: TabId[];
	current: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppTabs',
  props: {
    tabs: {},
    current: {}
  },
  emits: [
	'open',
],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["app-tab", {
				active: __props.current === tab.id,
			}]),
        key: tab.id,
        onClick: ($event: any) => (emit('open', tab.id))
      }, _toDisplayString(tab.name), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})